module.exports = __webpack_public_path__ + "static/media/4.356ec213.png";